import type {
  ChangePasswordUserRequest,
  LoginRequest,
  SignUpRequest,
  UnlockUserRequest,
  UserInfoRequest,
  ValidateUserByEmailRequest,
} from "../../../types/request/auth.request.type";
import type {
  LoginResponse,
  LogoutResponse,
  SignUpResponse,
  UserInfoResponse,
} from "../../../types/response/auth.response.type";
import { GET, POST } from "../../../utils/enum/requestMethods.enum";
import { reduxApiService } from "../../services/reduxApi.service";
import { SecurityApiRoutes } from "../../../utils/mapping/apiRoutes.mapping";

export const authApi = reduxApiService.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (requestParams) => ({
        url: SecurityApiRoutes.login,
        method: POST,
        body: { ...requestParams },
      }),
    }),
    logout: builder.query<LogoutResponse, void>({
      query: () => SecurityApiRoutes.logout,
    }),
    sendCodeVerification: builder.mutation<void, string>({
      query: (requestParam) => ({
        url: `${SecurityApiRoutes.sendCodeVerification}`,
        params: { pMail: requestParam },
        method: POST,
      }),
    }),
    getUserInfo: builder.mutation<UserInfoResponse[], UserInfoRequest>({
      query: (requestParam) => ({
        url: `${SecurityApiRoutes.getUserInfo}`,
        params: { ...requestParam },
        method: GET,
      }),
    }),
    signUp: builder.mutation<SignUpResponse, SignUpRequest>({
      query: (requestParam) => ({
        url: `${SecurityApiRoutes.signUp}`,
        body: { ...requestParam },
        method: POST,
      }),
    }),
    unlockUser: builder.mutation<number, UnlockUserRequest>({
      query: (requestParam) => ({
        url: `${SecurityApiRoutes.unlockUser}`,
        params: { ...requestParam },
        method: GET,
      }),
    }),
    changePasswordUser: builder.mutation<number, ChangePasswordUserRequest>({
      query: (requestParam) => ({
        url: `${SecurityApiRoutes.changePasswordUser}`,
        params: { ...requestParam },
        method: GET,
      }),
    }),
    validateUserByEmail: builder.mutation<boolean, ValidateUserByEmailRequest>({
      query: (requestParam) => ({
        url: `${SecurityApiRoutes.validateUserByEmail}`,
        params: { ...requestParam },
        method: GET,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLazyLogoutQuery,
  useSendCodeVerificationMutation,
  useGetUserInfoMutation,
  useSignUpMutation,
  useUnlockUserMutation,
  useChangePasswordUserMutation,
  useValidateUserByEmailMutation,
} = authApi;
